export enum MaterialFilterOptionTypes {
  AprilCollection = 'april collection',
  Assessments = 'assessments',
  AudioActivities = 'audio activities',
  BlendingAndDecodingPractice = 'blending & decoding practice',
  Book1 = 'book 1',
  Book2 = 'book 2',
  Book3 = 'book 3',
  Cards = 'cards',
  CenterActivities = 'center activities',
  CombinationsFor10 = 'combinations for 10',
  CoreInstructionalMaterials = 'core instructional materials',
  CoreMaterials = 'core materials',
  CorrelationsToStateStandards = 'correlations to state standards',
  CraneiumCompetition = 'crane-ium competition',
  CrossCurricularActivities = 'cross-curricular activities',
  DecemberCollection = 'december collection',
  DifferentiatedInstruction = 'differentiated instruction',
  Doubles = 'doubles',
  Ebook = 'ebook',
  Eights = '8s',
  ExtraPractice = 'extra practice',
  FebruaryCollection = 'february collection',
  Fives = '5s',
  Fours = '4s',
  HandsOnGames = 'hands-on games',
  IndependentStudentActivities = 'independent student activities',
  InstructionalGuidesAndTips = 'instructional guides & tips',
  InstructionalOverview = 'instructional overview',
  Interactive = 'interactive',
  InteractiveWhiteboardActivities = 'interactive whiteboard activities',
  JanuaryCollection = 'january collection',
  JuneCollection = 'june collection',
  LandingPages = 'landing pages',
  LessonResources = 'lesson resources',
  Lessons = 'lessons',
  Lists = 'lists',
  Make10OrPretend10 = 'make-10 or pretend-10',
  MarchCollection = 'march collection',
  MayCollection = 'may collection',
  NearDoubles = 'near doubles',
  Nines = '9s',
  NovemberCollection = 'november collection',
  OctoberCollection = 'october collection',
  PartnerPractice = 'partner practice',
  PlacementCheckpoints = 'placement checkpoints',
  PlanningMaterials = 'planning materials',
  PlusAndMinus012 = 'Plus and Minus 0-1-2',
  Printables = 'printables',
  ProfessionalDevelopment = 'professional development',
  ReadAlouds = 'read-alouds',
  ReadingMaterials = 'reading materials',
  ReproduciblePages = 'reproducible pages',
  SchoolHomeCommunications = 'school-home communications',
  SeptemberCollection = 'september collection',
  Sevens = '7s',
  Sixes = '6s',
  SkillsOverview = 'skills overview',
  SkillsPractice = 'skills practice',
  Songs = 'songs',
  SquaresAndNearSquares = 'squares and near squares',
  StageA = 'stage a',
  StageB = 'stage b',
  StageC = 'stage c',
  StageD = 'stage d',
  StageE = 'stage e',
  StageF = 'stage f',
  StudentPages = 'student pages',
  StudentWorkbooks = 'student workbooks',
  SumsWithin5 = 'sums within 5',
  TeachersGuidesAndTips = 'teacher\'s guides & tips',
  TeacherEdition = 'teacher edition',
  Tens = '10s',
  TenAndSomeMore = '10 and some more',
  Threes = '3s',
  TrackingAndMonitoring = 'tracking and monitoring',
  TrainingMaterials = 'training materials',
  Twos = '2s',
  Videos = 'videos',
  WholeClassInstruction = 'whole-class instruction',
}
